/**
 * API tarih formatı: "DD-MM-YYYY HH:mm"
 * datetime-local input formatı: "YYYY-MM-DDTHH:mm"
 */

/**
 * API formatından datetime-local input formatına çevirir
 * "DD-MM-YYYY HH:mm" -> "YYYY-MM-DDTHH:mm"
 */
export const parseDateTime = (dateTimeString) => {
  if (!dateTimeString) return "";
  const [datePart, timePart] = dateTimeString.split(" ");
  if (!datePart || !timePart) return "";
  const [day, month, year] = datePart.split("-");
  return `${year}-${month}-${day}T${timePart}`;
};

/**
 * datetime-local input formatından API formatına çevirir
 * "YYYY-MM-DDTHH:mm" -> "DD-MM-YYYY HH:mm"
 */
export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return "";
  const [datePart, timePart] = dateTimeString.split("T");
  if (!datePart || !timePart) return "";
  const [year, month, day] = datePart.split("-");
  return `${day}-${month}-${year} ${timePart}`;
};


